var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card-revenue-budget",attrs:{"no-body":""}},[_c('vue-apex-charts',{attrs:{"id":"revenue-report-chart","height":"230","options":_vm.revenueReport.chartOptions,"series":_vm.revenueReport.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }